const getters = {
  getPermissions: (state) => state.permissions,
  getPermission: (state) => state.permission,
};

export default getters;
